<template>
  <ReportsHistory
    pageTitle="Aplicação de férias"
    :reports="reports"
    :loading="loading"
    @changeShowTable="changeShowTable"
    :showDataTable="showDataTable"
    :period-selected="periodSelected"
    @reload:reports="getVacationApplyReports"
    @update:period-selected="
      handleUpdatePeriod('periodSelected', $event, getVacationApplyReports)
    "
    itemKey="created_at"
    :applyUtc="false"
  />
</template>

<script>
import ReportsHistory from "@/components/logs/ReportsHistory.vue";
import { subtractDays } from "@/helpers/services/utils";
import { mapGetters, mapMutations } from "vuex";

export default {
  name: "ReportsVacationApply",

  components: {
    ReportsHistory,
  },

  data() {
    return {
      reports: [],
      loading: false,
      showDataTable: false,
      periodSelected: { textKey: "common.past7Days", value: subtractDays(7) },
    };
  },
  computed: {
    ...mapGetters(["token", "clientToken", "isResellerPage"]),

    ...mapMutations(["setSnackBar"]),
  },
  methods: {
    async changeShowTable() {
      this.showDataTable = !this.showDataTable;
      if (!this.reports.length) {
        await this.getVacationApplyReports();
      }
    },

    async getVacationApplyReports() {
      this.loading = true;

      let clientToken = "";
      if (this.isResellerPage && this.clientToken) {
        clientToken = `Bearer ${this.clientToken}`;
      }

      const from_date = this.periodSelected.value;
      const url = `${process.env.VUE_APP_API_BASE_URL}/company/history/vacation?from_date=${from_date}`;

      const config = {
        headers: {
          Authorization: clientToken ? clientToken : this.token,
        },
      };

      await this.$axios
        .get(url, config)
        .then(({ data }) => {
          this.reports = data;
        })
        .catch((err) => {
          this.setSnackBar({
            message:
              "Erro ao recuperar os registros de aplicação de férias, tente novamente.",
            color: "error",
            show: true,
          });
          console.error("getVacationApplyReports()", err);
        })
        .finally(() => (this.loading = false));
    },

    async handleUpdatePeriod(periodSelected, event, reportGetter) {
      this[periodSelected] = event;
      await reportGetter();
    },
  },
  async beforeMount() {
    if (!this.isResellerPage) {
      await this.getVacationApplyReports();
    }
  },
};
</script>
